import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '1.1rem',
  padding: 0,
  color: 'primary.main',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
}));

export const ChartOptionLabels = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  paddingLeft: theme.spacing(5),
  fontSize: '1.1rem',
}));